import React, { useMemo } from "react";
import { STEP_LIST, STEP_NAMES } from "./constants";
import styles from "./styles.css";
// import ProgressBarLinear from "../../shared/progress-bar-linear";
import PropTypes from "prop-types";
import Cross from "./images/cross.svg";
import { SCREEN_NAMES } from "../pre-delivery-inspection-lead-form-parent/constant";
// import PreDeliveryInspectionLocationWithLogin from "../pre-delivery-inspection-location-with-login";
import getPdiStepDetails from "../../../utils/helpers/get-pdi-step-details";
import { NUMBER } from "../../../constants/app-constants";
// import { Modal } from "@cars24/turbo-web/lib/modal";
import { Label } from "@cars24/turbo-web/lib/label";
import { IconButton } from "@cars24/turbo-web/lib/icon-button";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Button } from "@cars24/turbo-web/lib/button";

const VehicleInformation = ({
    setFormActiveScreenConnect,
    preDeliveryInspectionLeadData,
    setActiveAccordionStepIndexConnect
    // isLoggedIn
}) => {
    // const [isOpen, setIsOpen] = useState(false);
    const { tokens } = useTokens();
    const {
        activeAccordionStepIndex = NUMBER.ZERO,
        brand: { id: brandId = ""},
        model: { id: modelId = ""},
        newCarPdiLead = false
    } = preDeliveryInspectionLeadData || {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const { isVisible } = useMemo(() => getPdiStepDetails(preDeliveryInspectionLeadData || {}), [brandId, modelId]);

    const handleBack = () => {
        setFormActiveScreenConnect(newCarPdiLead ? SCREEN_NAMES.intentScreen : SCREEN_NAMES.mainFormScreen);
    };

    const handleConfirm = () => {
        setFormActiveScreenConnect(SCREEN_NAMES.confirmCarDetailsScreen);
    };

    const handleStep = (data, index) => {
        const {reduxStateKey = ""} = data || {};
        if ((reduxStateKey === STEP_NAMES.Model
            && preDeliveryInspectionLeadData[STEP_NAMES.Brand]
            && preDeliveryInspectionLeadData[STEP_NAMES.Brand].id)
            || reduxStateKey !== STEP_NAMES.Model
        ) {
            setActiveAccordionStepIndexConnect(index);
        }
    };

    const getTabStyle = (data, index) => {
        const {reduxStateKey = ""} = data || {};
        if (index === activeAccordionStepIndex) return "styles.active";
        if (preDeliveryInspectionLeadData[reduxStateKey] && preDeliveryInspectionLeadData[reduxStateKey].id) return "styles.stepFilled";
        else return "styles.defaultTab";
    };

    return (
        <React.Fragment>
            <div styleName={"styles.headerWrapper"}>
                <div styleName={"styles.header"}>
                    <div styleName={"styles.headertitle"}>
                        <IconButton onClick={handleBack} size="small" rounded={true}>
                            <img src={Cross} alt="cross" />
                        </IconButton>
                        <Label level={NUMBER.THREE} fontWeight="semibold">Enter car details</Label>
                    </div>
                    <div styleName={"styles.tabs"}>
                        {STEP_LIST.map((item, index) => (
                            <div
                                key={`step-${index}`}
                                onClick={() => handleStep(item, index)}
                                styleName={`styles.stepBox ${getTabStyle(item, index)}`}
                            >
                                {item.displayName}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div styleName={"styles.leadFormWrapper"}>
                <div styleName={"styles.brandsWrapper"}>
                    {STEP_LIST.map(({ heading, Component }, index) => {
                        return (
                            activeAccordionStepIndex === index &&
                            <div key={`step-${index}`}>
                                <div styleName={"styles.stepHeadingContainer"}>
                                    <Label level={NUMBER.THREE} fontWeight="semibold" color={tokens.text_default_text_primary}>{heading}</Label>
                                </div>
                                <Component />
                            </div>
                        );
                    })}
                </div>
                {isVisible &&
                    <div styleName={"styles.confirmCta"}>
                        <Button onClick={handleConfirm} label="Confirm" type="primary" size="medium" />
                    </div>
                }
            </div>
        </React.Fragment>
    );
};

export default VehicleInformation;

VehicleInformation.propTypes = {
    setFormActiveScreenConnect: PropTypes.func,
    preDeliveryInspectionLeadData: PropTypes.object,
    setActiveAccordionStepIndexConnect: PropTypes.func
};
